/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { startTransition, StrictMode } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HydratedRouter } from 'react-router/dom';
import { preloadServerRenderedComponents } from '@/lib/page-designer/preload-components';

// Same as the React Router default client entry, except that the Page Designer components present in the
// server-rendered HTML are loaded first, so hydration doesn't suspend on them and re-render their content
// (layout shift). The preload is bounded by a timeout and never prevents hydration.
void preloadServerRenderedComponents()
    .catch(() => undefined)
    .finally(() => {
        startTransition(() => {
            hydrateRoot(
                document,
                <StrictMode>
                    <HydratedRouter />
                </StrictMode>
            );
        });
    });
